import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginComponent} from './components/login/login.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {HttpConfigInterceptor} from "./utilities/http-config.interceptor";
import {SideMenuComponent} from './components/side-menu/side-menu.component';
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatButtonModule} from "@angular/material/button";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListModule} from "@angular/material/list";
import {MatIconModule} from "@angular/material/icon";
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {HttpErrorHandlingInterceptor} from "./utilities/http-error-handling.interceptor";
import {MatDialogModule} from "@angular/material/dialog";
import {MatSelectModule} from "@angular/material/select";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatTooltipModule} from "@angular/material/tooltip";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {MatMenuModule} from "@angular/material/menu";
import {MatCardModule} from "@angular/material/card";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatChipsModule} from "@angular/material/chips";
import {AuditlogComponent} from './components/auditlog/auditlog.component';
import {LeafletMarkerClusterModule} from "@asymmetrik/ngx-leaflet-markercluster";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatTreeModule} from "@angular/material/tree";
import {MatTabsModule} from "@angular/material/tabs";
import {ProdGridConfigService, ProdGridModule} from 'prod-grid';
import {ProdDialogModule} from 'prod-dialog';
import {ProdFormModule} from 'prod-form';
import {ProdSelectModule} from 'prod-select';
import {ProdSharedModule} from 'prod-shared';
import {ProdMapModule} from 'prod-map';
import {UsersComponent} from "./components/users/users.component";
import {UserFormComponent} from "./components/users/form/user-form.component";
import {PermissionComponent} from "./components/permission/permission.component";
import {FirmwareComponent} from "./components/firmware/firmware.component";
import {DeviceEventsComponent} from "./components/device-events/device-events.component";
import {CarsComponent} from "./components/cars/cars.component";
import {CarFormComponent} from "./components/cars/form/car-form.component";
import {BatteryEventsGridComponent} from "./components/cars/form/battery-events-grid/battery-events-grid.component";
import {FirmwareFormComponent} from "./components/firmware/form/firmware-form/firmware-form.component";
import {CompanyComponent} from './components/company/company.component';
import {SiteComponent} from "./components/company/site/site.component";
import {CompanyDetailComponent} from "./components/company/company-detail/company-detail.component";
import {CompanyBatteryComponent} from "./components/company/company-battery/company-battery.component";
import {SiteDetailComponent} from "./components/company/site-detail/site-detail.component";
import {CompanyGroupComponent} from "./components/company/company-group/company-group.component";
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {BatteryEventsForm} from "./components/cars/form/battery-events-grid/battery-events-form/battery-events-form";
import {TreeSelect} from "./components/tree-select/tree-select";
import {SiteForm} from "./components/company/site/site-form/site-form";
import {HubForm} from "./components/company/site-detail/hub-form/hub-form";
import {Help} from "./components/help/help";
import {HelpForm} from "./components/help/help-form/help-form";
import {HelpGrid} from "./components/help/help-grid/help-grid";
import {CompanyGroupForm} from "./components/company/company-group/company-group-form/company-group-form";
import {OrganizationsComponent} from './components/organizations/organizations.component';
import {CompanyFormComponent} from './components/organizations/company-form/company-form.component';
import {AngularSplitModule} from "angular-split";
import {HeartbeatGridComponent} from './components/company/site-detail/heartbeat-grid/heartbeat-grid.component';
import {NgxEchartsModule} from "ngx-echarts";
import {DipGridFilterForm} from "./dip/dip-grid-filter/dialog/form/dip-grid-filter-form";
import {DipGridFilterDialog} from "./dip/dip-grid-filter/dialog/dip-grid-filter-dialog";
import {DipGridFilter} from "./dip/dip-grid-filter/dip-grid-filter";
import {ProdGridConfig} from "./models/prod-grid-config";
import {ResetPasswordComponent} from './components/login/reset-password/reset-password.component';
import {CarsCurrentStatisticsComponent} from './components/dashboard/current/cars-current-statistics/cars-current-statistics.component';
import {CurrentComponent} from './components/dashboard/current/current.component';
import {HistoricalComponent} from './components/dashboard/historical/historical.component';
import {CommunicationLogComponent} from "./components/communication-log/communication-log.component";
import { DistributorComponent } from './components/distributor/distributor.component';
import { DistributorGroupComponent } from './components/distributor/distributor-group/distributor-group.component';
import { DistributorGroupFormComponent } from './components/distributor/distributor-group/distributor-group-form/distributor-group-form.component';
import { DistributorFormComponent } from './components/organizations/distributor-form/distributor-form.component';
import { DistributorUserComponent } from './components/distributor/distributor-user/distributor-user.component';
import { DistributorUserFormComponent } from './components/distributor/distributor-user/distributor-user-form/distributor-user-form.component';
import { DistributorDetailComponent } from './components/distributor/distributor-detail/distributor-detail.component';
import { ChangeCompanyDialogComponent } from './components/cars/form/change-company-dialog/change-company-dialog.component';
import { ScannerComponent } from './components/scanner/scanner.component';
import {ZXingScannerModule} from "@zxing/ngx-scanner";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {take} from "rxjs";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MultiTranslateHttpLoader} from "ngx-translate-multi-http-loader";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SideMenuComponent,
    ChangePasswordComponent,
    AuditlogComponent,
    UsersComponent,
    UserFormComponent,
    PermissionComponent,
    FirmwareComponent,
    FirmwareFormComponent,
    DeviceEventsComponent,
    CarsComponent,
    CarFormComponent,
    BatteryEventsGridComponent,
    CompanyComponent,
    SiteComponent,
    CompanyDetailComponent,
    CompanyBatteryComponent,
    SiteDetailComponent,
    CompanyGroupComponent,
    DashboardComponent,
    BatteryEventsForm,
    SiteForm,
    HubForm,
    TreeSelect,
    Help,
    HelpForm,
    HelpGrid,
    CompanyGroupForm,
    OrganizationsComponent,
    CompanyFormComponent,
    HeartbeatGridComponent,
    DipGridFilterForm,
    DipGridFilterDialog,
    DipGridFilter,
    ResetPasswordComponent,
    CarsCurrentStatisticsComponent,
    CurrentComponent,
    HistoricalComponent,
    CommunicationLogComponent,
    DistributorComponent,
    DistributorGroupComponent,
    DistributorGroupFormComponent,
    DistributorFormComponent,
    DistributorUserComponent,
    DistributorUserFormComponent,
    DistributorDetailComponent,
    ChangeCompanyDialogComponent,
    ScannerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTooltipModule,
    DragDropModule,
    MatMenuModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatChipsModule,
    LeafletMarkerClusterModule,
    FlexLayoutModule,
    MatExpansionModule,
    MatTreeModule,
    MatTabsModule,
    MatProgressBarModule,
    ProdSharedModule,
    ProdMapModule,
    ProdSelectModule,
    ProdDialogModule,
    ProdDialogModule,
    ProdGridModule.forRoot(new ProdGridConfig()),
    ProdFormModule,
    AngularSplitModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    ZXingScannerModule,
    TranslateModule.forRoot({
      defaultLanguage: 'hu',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false
    })
  ],
  providers: [
    ProdGridConfigService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorHandlingInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

export function appInitializerFactory(translateService: TranslateService): () => Promise<any> {
  return () => new Promise<any>((resolve: any) => {
    translateService.use( 'en')
      .pipe(take(1))
      .subscribe(() => {
        },
        (error) => {
        },
        () => {
          resolve(null)
        });
  });
}

export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [{prefix: './assets/i18n/', suffix: '.json'}, {prefix: './assets/i18n/prod-common-lib/', suffix: '.json'}]);
}
